export const countries = [
	{
		id: 65,
		name: "Egypt",
		iso3: "EGY",
		iso2: "EG",
		numeric_code: "818",
		phone_code: "20",
		capital: "Cairo",
		currency: "EGP",
		currency_name: "Egyptian pound",
		currency_symbol: "ج.م",
		tld: ".eg",
		native: "مصر‎",
		region: "Africa",
		subregion: "Northern Africa",
		latitude: "27.00000000",
		longitude: "30.00000000",
		emoji: "🇪🇬",
		hasStates: true,
	},
	{
		id: 194,
		name: "Saudi Arabia",
		iso3: "SAU",
		iso2: "SA",
		numeric_code: "682",
		phone_code: "966",
		capital: "Riyadh",
		currency: "SAR",
		currency_name: "Saudi riyal",
		currency_symbol: "﷼",
		tld: ".sa",
		native: "المملكة العربية السعودية",
		region: "Asia",
		subregion: "Western Asia",
		latitude: "25.00000000",
		longitude: "45.00000000",
		emoji: "🇸🇦",
		hasStates: true,
	},
];
